import React, { FC, useState } from "react";
import { EUserType, IAulasChamada } from "@deltasge/marauders-map";

import {
  Button,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  TextField,
} from "@mui/material";
import { getBNCC } from "utils";
import { ArrowTopRightThinCircleOutline } from "mdi-material-ui";
import { useAppSelector } from "store";

export const EditAula: FC<{
  grau?: string;
  aulas: IAulasChamada[];
  close: () => void;
  submit: (args: { aulas: IAulasChamada[]; outrasTurmas: boolean }) => void;
}> = ({ aulas, close, submit, grau }) => {
  const {
    usuario: { usuario },
  } = useAppSelector((state) => state);

  const aula = aulas[0];
  const podeOutrasTurmas =
    aulas.length == 1 && usuario?.tipoUsuario == EUserType.Professor;

  const [descricao, setDescricao] = useState(aula.descricaoChamada);
  const [outrasTurmas, setOutrasTurmas] = useState(false);

  return (
    <>
      <DialogContent dividers>
        <Grid container spacing={1}>
          <Grid item xs={podeOutrasTurmas ? 5 : 12}>
            <TextField
              defaultValue={
                usuario?.tipoUsuario == EUserType.Professor ||
                usuario?.tipoUsuario == EUserType.UsuarioSistema
                  ? usuario?.nome
                  : "Secretaria"
              }
              label="Cadastrado por"
              disabled
            />
          </Grid>
          {podeOutrasTurmas && (
            <Grid item xs={7}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={outrasTurmas}
                    onChange={() => setOutrasTurmas(!outrasTurmas)}
                  />
                }
                label="Gravar o mesmo conteúdo para todas as aulas e turmas desta série"
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <TextField
              value={descricao}
              multiline
              rows={8}
              label={
                aula.diaSemAula
                  ? "Descrição de dia sem aula"
                  : "Descrição do Conteúdo Ministrado"
              }
              onChange={async ({ target: { value } }) => {
                aula.descricao = value;
                setDescricao(value);
              }}
              helperText={"Interpreta código BNCC"}
              inputProps={{
                onKeyUp: async (e: any) => {
                  const valorNovo = await getBNCC(
                    e.target.value as string,
                    true
                  );
                  if (valorNovo) {
                    e.target.value = valorNovo;
                    setDescricao(valorNovo);
                  }
                },
              }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container justifyContent="space-between" spacing={1}>
          <Grid item>
            <Button
              startIcon={<ArrowTopRightThinCircleOutline />}
              onClick={() =>
                window.open(
                  `http://basenacionalcomum.mec.gov.br/abase/#${
                    grau === "1"
                      ? "fundamental"
                      : grau === "2"
                      ? "medio"
                      : "infantil"
                  }`,
                  "_blank"
                )
              }
              color="primary"
            >
              Consultar BNCC
            </Button>
          </Grid>
          <Grid item textAlign="right">
            <Button onClick={close} color="secondary" sx={{ mr: 1 }}>
              Cancelar
            </Button>
            <Button
              onClick={() => {
                aulas.forEach((aula) => {
                  aula.descricaoChamada = descricao;
                });
                close();
                submit({ outrasTurmas, aulas });
              }}
              color="primary"
            >
              Gravar
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
};
